import React, { useCallback, useEffect, useState } from "react";
import style from "css/app.module.css";
import alertStyle from "css/menu.module.css";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Alram } from "asset/header/alram.svg";
import { Cookies } from "react-cookie";
import { deleteUserInfo } from "redux/slices/userSlice";
import { deleteAllowPageInfo } from "redux/slices/allowPageSlice";
import { useNavigate } from "react-router-dom";
import { Modal, Select } from "antd";
import Alrampop from "components/common/alrampop";
import axios from "axios";
import { useTranslation } from "react-i18next";

/**
 * 파일명: Header.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: app Header
 */
function Header({ pageName }) {
  //selector
  const payload = useSelector((state) => state.user);
  const pathName = window.location.pathname;

  const { t, i18n } = useTranslation();
  const languageList = [
    { value: "ko-KR", label: t("LANGUAGE.ko") },
    { value: "en-US", label: t("LANGUAGE.en") },
  ];
  const [selectType, setSelectType] = useState(i18n.language);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [alramopen, setalramopen] = useState(false);
  const { confirm } = Modal;

  const logoutHandler = () => {
    confirm({
      className: alertStyle.logout_container,
      centered: true,
      title: (
        <p className={alertStyle.logout_title}>{t("LABEL.TITLE.LOGOUT")}</p>
      ),
      icon: (
        <img
          src={
            process.env.REACT_APP_CLIENT_URL + "img/common/modal_icon_green.png"
          }
          alt=""
          className={`${alertStyle.logout_icon} anticon`}
        />
      ),
      content: (
        <p className={alertStyle.logout_content}>
          {t("MESSAGE.LOGOUT_CONFIRM")}
        </p>
      ),
      okText: t("BTN.OK"),
      okType: "dashed",
      okButtonProps: {
        className: alertStyle.ok_btn,
      },
      cancelText: t("BTN.CANCEL"),
      cancelButtonProps: {
        className: alertStyle.cancel_btn,
        type: "dashed",
      },
      onOk() {
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const cookies = new Cookies();

        cookies.remove(authNm, { path: "/", domain: domain });
        cookies.remove(refreshNm, { path: "/", domain: domain });
        dispatch(deleteUserInfo());
        dispatch(deleteAllowPageInfo());
        navigate(process.env.REACT_APP_CLIENT_URL);
      },
    });
  };
  const alramclose = () => {
    setruncount(true);
    setalramopen(false);
  };
  const closealram = useCallback(() => {
    setruncount(true);
    setalramopen(false);
  }, []);

  useEffect(() => {
    if (alramopen) {
      window.addEventListener("click", closealram);
      return () => {
        window.removeEventListener("click", closealram);
      };
    }
  }, [alramopen, closealram]);

  const [alramdot, setalramdot] = useState(false);
  const [runcount, setruncount] = useState(true);
  const countalram = useCallback(() => {
    let config = {
      params: {
        TARGET_USER: payload.id,
      },
    };
    axios.get("/alram/countalram", config).then((res) => {
      if (res.status === 200) {
        if (res.data > 0) {
          setalramdot(true);
        } else {
          setalramdot(false);
        }
      }
    });
  }, [payload]);
  useEffect(() => {
    if (runcount) {
      countalram();
      if (payload.id !== "") {
        setruncount(false);
      }
    }
  }, [runcount, countalram, payload]);
  return (
    <header className={style.header}>
      {/* <p className={style.header_title}>{pageName}</p> */}
      <p className={style.header_title}>
        {pathName === "/app/mypage/schedule"
          ? t("MENU.내 일정")
          : pathName === "/app/meeting/room"
          ? t("MENU.회의실 현황")
          : t("MENU." + pageName)}
      </p>

      <section className={style.header_section}>
        {/* <p className={style.header_name}>{payload.name}님</p> */}
        <p className={style.header_name}>
          {t("WELCOME", { NAME: payload.name })}
        </p>
        <Select
          // type="short"
          options={languageList}
          value={selectType}
          onChange={(value) => {
            setSelectType(value);
            i18n.changeLanguage(value);
          }}
          style={{ marginLeft: "25px" }}
        />
        <div>
          <div
            className={`${style.header_alram} cursor`}
            onClick={(e) => {
              e.stopPropagation();
              alramopen ? alramclose() : setalramopen(true);
            }}
          >
            {alramdot ? <div className={style.alramdot} /> : <div></div>}

            <Alram />
          </div>
          {alramopen ? (
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <img
                alt=""
                src={
                  process.env.REACT_APP_CLIENT_URL + "img/alram/triangle.png"
                }
                className={style.triangle}
              />
              <Alrampop alrammoff={() => alramclose()} main={false} />
            </div>
          ) : (
            <div />
          )}
        </div>

        <div
          className={`${style.header_logout} cursor`}
          onClick={() => logoutHandler()}
        >
          Logout
        </div>
      </section>
    </header>
  );
}

export default Header;
